"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bboxOrNull = void 0;
const bbox_1 = __importDefault(require("@turf/bbox"));
const proj_1 = require("ol/proj");
function bboxOrNull(featureCollection) {
    try {
        const [minX, minY, maxX, maxY] = bbox_1.default(featureCollection);
        return [...proj_1.fromLonLat([minX, minY]), ...proj_1.fromLonLat([maxX, maxY])];
    }
    catch (_a) {
        return null;
    }
}
exports.bboxOrNull = bboxOrNull;
//# sourceMappingURL=bboxOrNull.js.map